var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFrance = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5207_30153)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.9997 7.5003C14.9997 4.27557 12.9644 1.52649 10.1084 0.466797V14.5338C12.9644 13.4741 14.9997 10.725 14.9997 7.5003Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 7.5003C0 10.725 2.03534 13.4741 4.89132 14.5338V0.466797C2.03534 1.52649 0 4.27557 0 7.5003Z",
  fill: "#0052B4"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5207_30153"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 15,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFrance);
export { ForwardRef as ReactComponent };